//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import { IPromotedPostsState } from '../models/AppState';
import {
    INITIAL_WIZARD_STATES,
    PROMOTED_POSTS_ACTIONS,
    PromotedPostsStatuses,
    WIZARD_STEPS,
} from '../promoted-posts-constants/promoted-posts-constants';

const initialState: IPromotedPostsState = {
  accountsExist: false,
  availableAccounts: null,
  availableAccountOptions: null,
  account: null,
  curalateAdId: null,
  cuid: null,
  itemId: null,
  imageUrl: null,
  caption: null,
  isFetchingAccountData: false,
  isUpdatingPromotion: false,
  promotionStatus: PromotedPostsStatuses.EDITING,
  activeStep: WIZARD_STEPS.ACCOUNT,
  wizardSteps: angular.copy(INITIAL_WIZARD_STATES),
};

export default function PromotedPostsReducer(state = initialState, action): IPromotedPostsState {
  switch (action.type) {
    case PROMOTED_POSTS_ACTIONS.CLEAR_PROMOTED_POSTS_STATE:
      return {
        ...initialState,
        wizardSteps: angular.copy(INITIAL_WIZARD_STATES),
      };
    case PROMOTED_POSTS_ACTIONS.SETUP_PROMOTED_POSTS:
      return {
        ...state,
        curalateAdId: action.payload.curalateAdId,
        cuid: action.payload.cuid,
        itemId: action.payload.itemId,
        imageUrl: action.payload.imageUrl,
        caption: action.payload.caption,
      };
    case PROMOTED_POSTS_ACTIONS.UPDATE_WIZARD_STATES:
      return {
        ...state,
        wizardSteps: action.payload,
      };
    case PROMOTED_POSTS_ACTIONS.REQUEST_AD_ACCOUNTS:
      return {
        ...state,
        isFetchingAccountData: true,
      };
    case PROMOTED_POSTS_ACTIONS.RECEIVE_AD_ACCOUNTS:
      return {
        ...state,
        accountsExist: action.payload.accountsExist,
        availableAccounts: action.payload.availableAccounts,
        availableAccountOptions: action.payload.availableAccountOptions,
        account: {
          id: action.payload.defaultAccountId,
          name: action.payload.defaultAccountName,
          creditCardText: action.payload.defaultAccountCard,
          currency: action.payload.defaultAccountCurrency,
          currencyCode: action.payload.defaultAccountCurrencyCode,
          minDailyBudget: action.payload.defaultAccountMinDailyBudget,
          maxDailyBudget: action.payload.defaultAccountMaxDailyBudget,
          highBudgetThreshold: action.payload.defaultAccountHighBudgetThreshold,
          businessPageId: action.payload.businessPageId,
          instagramBusinessId: action.payload.instagramBusinessId,
        },
        isFetchingAccountData: false,
      };
    case PROMOTED_POSTS_ACTIONS.UPDATE_SELECTED_ACCOUNT:
      return {
        ...state,
        account: action.payload,
      };
    case PROMOTED_POSTS_ACTIONS.CREATE_PROMOTION:
      return {
        ...state,
        isUpdatingPromotion: true,
      };
    case PROMOTED_POSTS_ACTIONS.UPDATE_PROMOTION_STATUS:
      return {
        ...state,
        promotionStatus: action.payload,
        isUpdatingPromotion: false,
      };
    default:
      return state;
  }
}
